export default __webpack_public_path__ + "df43eff.png";